var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.991211,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#85D754"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3266_10409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9912,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3266_10409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9912 32.7251V30.6751C28.4912 30.2418 29.6995 29.4084 30.6162 28.1751C31.5329 26.9418 31.9912 25.5418 31.9912 23.9751C31.9912 22.4084 31.5329 21.0084 30.6162 19.7751C29.6995 18.5418 28.4912 17.7084 26.9912 17.2751V15.2251C29.0579 15.6918 30.7412 16.7376 32.0412 18.3626C33.3412 19.9876 33.9912 21.8584 33.9912 23.9751C33.9912 26.0918 33.3412 27.9626 32.0412 29.5876C30.7412 31.2126 29.0579 32.2584 26.9912 32.7251ZM15.9912 27.0001V21.0001H19.9912L24.9912 16.0001V32.0001L19.9912 27.0001H15.9912ZM26.9912 28.0001V19.9501C27.7745 20.3168 28.387 20.8668 28.8287 21.6001C29.2704 22.3334 29.4912 23.1334 29.4912 24.0001C29.4912 24.8501 29.2704 25.6376 28.8287 26.3626C28.387 27.0876 27.7745 27.6334 26.9912 28.0001ZM22.9912 20.8501L20.8412 23.0001H17.9912V25.0001H20.8412L22.9912 27.1501V20.8501Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.f77577ae710220d8ab053d34fea66c0f.svg";
export { ForwardRef as ReactComponent };